import request from '@/utils/request'
// 工单处理
export function processing(data) {
    return request({
        url:'/netbar/api/maintenance_detail/v1/list',
        method:'post',
        data
    })
}
// 工单详情
export function workorderDetails(data) {
    return request({
        url:'/netbar/api/maintenance_detail/v1/detail',
        method:'post',
        data
    })
}
// 接单
export function workorderPickUp(data) {
    return request({
        url:'/netbar/api/maintenance_detail/v1/order_receiving',
        method:'post',
        data
    })
}
//  关闭订单
export function workorderClose(data) {
    return request({
        url:'/netbar/api/maintenance_detail/v1/close_order',
        method:'post',
        data
    })
}
// 处理完毕
export function workorderSucess(data) {
    return request({
        url:'/netbar/api/maintenance_detail/v1/figure_out',
        method:'post',
        data
    })
}